document.addEventListener('DOMContentLoaded', function () {
  if (window.__petrelRevealInit) return;
  window.__petrelRevealInit = true;

  var els = document.querySelectorAll('.petrel-reveal');
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.14 });
  els.forEach(function (el) { io.observe(el); });
});

// Re-observe reveal elements injected by the theme editor (section reload)
document.addEventListener('shopify:section:load', function (evt) {
  var els = evt.target.querySelectorAll('.petrel-reveal');
  els.forEach(function (el) { el.classList.add('in'); });
});

// ---------- Petrel PDP: gallery thumbnails ----------
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.petrel-pdp-gallery').forEach(function (gallery) {
    var mainImg = gallery.querySelector('.petrel-pdp-gallery-main img');
    var thumbs = gallery.querySelectorAll('.petrel-pdp-thumb');
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = btn.getAttribute('data-full');
        thumbs.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  });

  // ---------- Petrel PDP: variant selection ----------
  document.querySelectorAll('[data-petrel-variants]').forEach(function (scriptTag) {
    var info = scriptTag.closest('.petrel-pdp-info');
    if (!info) return;
    var form = info.querySelector('#petrel-product-form, form[id^="petrel-product-form"]');
    if (!form) return;

    var variants;
    try { variants = JSON.parse(scriptTag.textContent); } catch (e) { return; }

    var selects = form.querySelectorAll('.petrel-pdp-select');
    var hiddenId = form.querySelector('input[name="id"]');
    var priceEl = info.querySelector('.petrel-pdp-price');
    var addBtn = form.querySelector('.petrel-pdp-add');

    function currentOptions() {
      var opts = [];
      selects.forEach(function (s) { opts.push(s.value); });
      return opts;
    }
    function findVariant(opts) {
      return variants.filter(function (v) {
        return v.options.every(function (val, i) { return val === opts[i]; });
      })[0];
    }
    function updateUI() {
      var match = findVariant(currentOptions());
      if (!match) return;
      if (hiddenId) hiddenId.value = match.id;
      if (priceEl) priceEl.textContent = match.price_formatted;
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available
          ? addBtn.getAttribute('data-label-add')
          : addBtn.getAttribute('data-label-sold-out');
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', updateUI); });
  });
});
